function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as suplierCouponsApi from '@/api/suplierCouponsApi.js';
import * as productSetting from '@/api/productSetting.js';
import { Debounce } from '@/utils/validate';
export default {
  components: {},
  data: function data() {
    return {
      loading: false,
      visible: false,
      pram: {},
      details: {},
      // 预留一份数据
      supplierId: '',
      nameList: []
    };
  },
  mounted: function mounted() {
    this.pram = {};
  },
  methods: {
    openInit: function openInit(supplierId) {
      var _this = this;
      this.supplierId = supplierId;
      this.details = {};
      this.pram = {};
      this.nameList = [];
      productSetting.getComDetail(supplierId).then(function () {
        var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        _this.visible = true;
        _this.details = res;
        _this.pram = _objectSpread({}, res);
        if (res !== null && res !== void 0 && res.params) {
          var _Object$keys;
          (_Object$keys = Object.keys(res.params)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.forEach(function (paramsKey) {
            _this.nameList.push({
              key: paramsKey,
              value: res.params[paramsKey]
            });
          });
        }
        ;
      });
    },
    handerSubmit: Debounce(function (form) {
      var _this$nameList,
        _this2 = this;
      this.loading = true;
      var _ref = this.pram || {},
        corrAmount = _ref.corrAmount,
        priceType = _ref.priceType,
        id = _ref.id;
      var params = {};
      ((_this$nameList = this.nameList) === null || _this$nameList === void 0 ? void 0 : _this$nameList.length) && this.nameList.forEach(function (item) {
        params[item.key] = item.value;
        // let isPass = item.key&&(item.value||item.value==0);
        // if(isPass) {
        //   params[item.key]=item.value;
        // };
      });
      productSetting.UpdateArticle({
        corrAmount: corrAmount,
        priceType: priceType,
        id: id,
        params: params
      }).then(function (data) {
        _this2.$message.success('操作成功');
        _this2.loading = false;
        _this2.visible = false;
        _this2.$emit('doRefresh');
      }).catch(function () {
        _this2.loading = false;
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    },
    removeNameItem: function removeNameItem(i) {
      this.nameList.splice(i, 1);
    }
  }
};